export default __webpack_public_path__ + "static/media/kweak.3b5d64ae.svg";